// extracted by mini-css-extract-plugin
module.exports = {"row":"row--3KX1M"};